import React, { useState, useEffect } from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import authortrackingStyle from './AuthorTrackingPage.module.css'
import BackBar from '../../components/BackBar/BackBar';
import { Link } from 'react-router-dom';
import { FiTrash2 } from "react-icons/fi";
import { HiMiniArrowRightEndOnRectangle } from "react-icons/hi2";
import { FaEnvelopeOpenText } from "react-icons/fa";
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import axios from 'axios'

export default function AuthorTrackingPage() {
  const [authors, setAuthors] = useState([]);
  const [filteredAuthors, setFilteredAuthors] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch the data from your PHP API
    const fetchAuthors = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?author_tracking=author_tracking`);
        const data = await response.json();
        if (data.success) {
          setAuthors(data.users);
          setFilteredAuthors(data.users);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAuthors();
  }, []);

  // Handle search input change
  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);

    if (searchValue === '') {
      setFilteredAuthors(authors);
    } else {
      const filtered = authors.filter(author =>
        author.f_name?.toLowerCase().includes(searchValue) ||
        author.l_name?.toLowerCase().includes(searchValue) ||
        author.email_id?.toLowerCase().includes(searchValue) ||
        author.phone?.toLowerCase().includes(searchValue)
      );
      setFilteredAuthors(filtered);
    }
  };

  // Handle Deactivate Author
  // const handleDeactivate = async (author) => {
  //   try {
  //       // Make the API call to activate the school  
  //       const isCurrentlyActive = author.flag == 1;

  //       const title = isCurrentlyActive 
  //         ? "Author Activated!" 
  //         : "Author Deactivated!";

  //       const text = isCurrentlyActive
  //         ? "Author Activated Successfully!"
  //         : "Author Deactivated Successfully!";
  //       const isCurrentlyActiveflag = author.flag == 0 ? 1 : 0;
  //       const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?author_deactivate=${author.author_id}&author_flag=${author.flag}`);
  //       const data = await response.json();
  //       if(data.success){
  //         Swal.fire({
  //           title: title,
  //           text: text,
  //           icon: "success",
  //           timer: 2000, // Pop-up duration in milliseconds
  //           showConfirmButton: false, // No need for a confirmation button
  //         }).then(() => {
  //           // Reload the page after the notification
  //           window.location.reload();
  //         });
  //       }
  //       else {
  //         Swal.fire({
  //           title: "Failed!",
  //           text: "Failed to activate or deactivate author!",
  //           icon: "error",
  //           timer: 2000, // Pop-up duration in milliseconds
  //           showConfirmButton: false, // No need for a confirmation button
  //         }).then(() => {
  //           // Reload the page after the notification
  //           window.location.reload();
  //         });
  //       }
  //     } catch (error) {
  //       console.error('Error activating school:', error);
  //       Swal.fire({
  //         title: "Failed!",
  //         text: "Something went wrong!",
  //         icon: "error",
  //         timer: 2000, // Pop-up duration in milliseconds
  //         showConfirmButton: false, // No need for a confirmation button
  //       }).then(() => {
  //         // Reload the page after the notification
  //        // window.location.reload();
  //       });
  //     }
  // };

  const handleDeactivate = async (author) => {

    const isCurrentlyActive = author.flag == 1;

    const actionText = isCurrentlyActive ? "deactivate" : "activate";

    const successTitle = isCurrentlyActive
      ? "Author Deactivated!"
      : "Author Activated!";

    const successText = isCurrentlyActive
      ? "Author Deactivated Successfully!"
      : "Author Activated Successfully!";

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${actionText} this author?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: `Yes, ${actionText} it!`,
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?author_deactivate=${author.author_id}&author_flag=${author.flag}`
      );

      const data = await response.json();

      if (data.success) {
        Swal.fire({
          title: successTitle,
          text: successText,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });

      } else {
        Swal.fire({
          title: "Failed!",
          text: `Failed to ${actionText} author!`,
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }

    } catch (error) {
      console.error('Error:', error);

      Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };


  // Handle Deactivate Author
  const handleDelete = async (authorID) => {
    // Step 1: Show confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the author!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    // If user cancels, exit function
    if (!result.isConfirmed) return;

    try {
      // Make the API call to activate the school  

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?author_delete=${authorID}`);
      const data = await response.json();
      if (data.success) {
        Swal.fire({
          title: "Success",
          text: "Author deleted successfully!",
          icon: "success",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Reload the page after the notification
          window.location.reload();
        });
      }
      else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to activate or deactivate author!",
          icon: "error",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Reload the page after the notification
          window.location.reload();
        });
      }
    } catch (error) {
      console.error('Error activating school:', error);
      Swal.fire({
        title: "Failed!",
        text: "Something went wrong!",
        icon: "error",
        timer: 2000, // Pop-up duration in milliseconds
        showConfirmButton: false, // No need for a confirmation button
      }).then(() => {
        // Reload the page after the notification
        window.location.reload();
      });
    }
  };

  // Handle Deactivate Author
  // const handleResetPassword = async (authorID) => {
  //   try {
  //     // Make the API call to activate the school  

  //     const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?author_pwd_reset=${authorID}`);
  //     const data = await response.json();
  //     if(data.success){
  //       Swal.fire({
  //         title: "Success",
  //         text: "Password reset successfully!",
  //         icon: "success",
  //         timer: 2000, // Pop-up duration in milliseconds
  //         showConfirmButton: false, // No need for a confirmation button
  //       }).then(() => {
  //         // Reload the page after the notification
  //         window.location.reload();
  //       });
  //     }
  //     else {
  //       Swal.fire({
  //         title: "Failed!",
  //         text: "Failed to  reset Password!",
  //         icon: "error",
  //         timer: 2000, // Pop-up duration in milliseconds
  //         showConfirmButton: false, // No need for a confirmation button
  //       }).then(() => {
  //         // Reload the page after the notification
  //         window.location.reload();
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error activating school:', error);
  //     Swal.fire({
  //       title: "Failed!",
  //       text: "Something went wrong!",
  //       icon: "error",
  //       timer: 2000, // Pop-up duration in milliseconds
  //       showConfirmButton: false, // No need for a confirmation button
  //     }).then(() => {
  //       // Reload the page after the notification
  //       window.location.reload();
  //     });
  //   }
  // };

  const handleResetPassword = async (email) => {
    try {
      const { value: formData } = await Swal.fire({
        title: 'Reset Password',
        html: `
        <input id="newPassword" type="password" class="swal2-input" placeholder="New Password">
        <input id="confirmPassword" type="password" class="swal2-input" placeholder="Confirm Password">
      `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Reset Password',
        preConfirm: () => {
          const newPassword = document.getElementById('newPassword').value;
          const confirmPassword = document.getElementById('confirmPassword').value;

          if (!newPassword || newPassword.length < 6) {
            Swal.showValidationMessage('Password must be at least 6 characters');
            return false;
          }

          if (newPassword !== confirmPassword) {
            Swal.showValidationMessage('Passwords do not match');
            return false;
          }

          return { email, newPassword, role: "admin" };
        }
      });

      if (!formData) return;

      // Call API
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/reset_password.php`,
        formData
      );

      if (response.data.success) {
        Swal.fire({
          title: "Success",
          text: "Password reset successfully!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        })
        // .then(() => window.location.reload());
      } else {
        Swal.fire({
          title: "Failed!",
          text: response.data.message || "Failed to reset password!",
          icon: "error",
        });
      }

    } catch (error) {
      console.error('Error resetting password:', error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
      });
    }
  };

  if (isLoading) {
    return <div></div>; // Show loading state while fetching data
  }

  // DataTable columns configuration
  const columns = [
    {
      name: 'First Name',
      selector: row => row.f_name,
      sortable: true,
      minWidth: '120px',
      cell: row => (
        <Link to={`/AuthorTrackingDetailsPage/${row.author_id}`} className="text-primary">
          {row.f_name}
        </Link>
      ),
    },
    {
      name: 'Last Name',
      selector: row => row.l_name,
      sortable: true,
      minWidth: '120px',
      cell: row => (
        <Link to={`/AuthorTrackingDetailsPage/${row.author_id}`} className="text-primary">
          {row.l_name}
        </Link>
      ),
    },
    {
      name: 'Email',
      selector: row => row.email_id,
      sortable: true,
      minWidth: '200px',
    },
    {
      name: 'Phone Number',
      selector: row => row.phone,
      sortable: true,
      minWidth: '120px',
    },
    {
      name: 'Author Page',
      sortable: true,
      minWidth: '120px',
      cell: row => (
        <Link to={`/AdminAuthorProfilePage/${row.author_id}`}>
          <HiMiniArrowRightEndOnRectangle className={authortrackingStyle.atArrowicon} />
        </Link>
      ),
    },
    {
      name: 'Deactivate',
      selector: row => row.author_id,
      sortable: true,
      minWidth: '120px',
      cell: row => (
        <button className={`btn ${row.flag == 0 ? `${authortrackingStyle.activateButton} btn-success` : `${authortrackingStyle.deactivateButton} btn-danger`}`} onClick={() => handleDeactivate(row)}>
          {row.flag == 0 ? "Activate" : "Deactivate"}
        </button>
      ),
    },
    {
      name: 'Reset Password',
      selector: row => row.author_id,
      sortable: true,
      minWidth: '120px',
      cell: row => (
        <button className={`${authortrackingStyle.resetButton} btn btn-warning`} onClick={() => handleResetPassword(row.email_id)}>
          Reset Password
        </button>
      ),
    },
    {
      name: 'Delete',
      selector: row => row.author_id,
      sortable: true,
      minWidth: '80px',
      cell: row => (
        <Link onClick={() => handleDelete(row.author_id)}>
          <FiTrash2 className={authortrackingStyle.atTrashicon} />
        </Link>
      ),
    },
  ];

  // Custom styles for the DataTable
  const customStyles = {
    table: {
      style: {
        backgroundColor: '#FFFFFF',
        border: 'none',
        borderRadius: '0px',
        borderCollapse: 'collapse',
        borderSpacing: 0,
      },
    },
    headRow: {
      style: {
        backgroundColor: '#FFFFFF',
        borderBottom: 'none',
        minHeight: '40px',
        borderCollapse: 'collapse',
      },
    },
    headCells: {
      style: {
        font: 'normal normal 600 10px/16px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'normal',
        textAlign: 'left',
        padding: '10px 5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
        overflow: 'visible',
      },
    },
    sortIcon: {
      style: {
        position: 'absolute !important',
        right: '8px !important',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
    rows: {
      style: {
        minHeight: '32px',
        fontSize: '10px',
        fontFamily: 'Poppins',
        fontWeight: 400,
        borderCollapse: 'collapse',
        color: '#707070',
        '&:not(:last-of-type)': {
          borderBottomStyle: 'none',
        },
      },
    },
    cells: {
      style: {
        font: 'normal normal 400 10px/24px Poppins',
        letterSpacing: '0px',
        color: '#707070',
        whiteSpace: 'nowrap',
        textAlign: 'left',
        padding: '5px',
        border: '1px solid #dee2e6',
        borderCollapse: 'collapse',
        justifyContent: 'center',
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        paddingTop: '15px',
        font: 'normal normal 400 12px/18px Poppins',
      },
      pageButtonsStyle: {
        color: '#001B64',
        fill: '#001B64',
      },
    },
  };

  return (
    <>
      <AdminHeader />
      <div className={authortrackingStyle.authortrackingpage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={authortrackingStyle.authortrackingBody}>
                <div className={authortrackingStyle.authortrackingPartone}>
                  <div className="row">
                    <div className='col-lg-7'>
                      <div className='row'>
                        <div className='col-lg-2'>
                          <label className={`${authortrackingStyle.atlabel} form-label`}>Search:</label>
                        </div>
                        <div className='col-lg-6'>
                          <input
                            type="text"
                            className={`${authortrackingStyle.atformControl} form-control mb-2`}
                            placeholder='By name, email, or phone number'
                            value={searchTerm}
                            onChange={handleSearch}
                          />
                        </div>
                        {/* <div className='col-lg-4'>
                        <button className={`${authortrackingStyle.inviteauthorButton} d-flex align-items-center justify-content-center btn btn-primary w-100`}> 
                          <FaEnvelopeOpenText className={`${authortrackingStyle.inviteIcons} me-2`} /> Invite Author
                        </button>
                      </div> */}
                      </div>
                    </div>
                    <div className='col-lg-5'> </div>
                  </div>
                </div>
                <div className={authortrackingStyle.authortrackingParttwo}>
                  <DataTable
                    columns={columns}
                    data={filteredAuthors}
                    pagination
                    paginationPerPage={5}
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    highlightOnHover
                    striped
                    responsive
                    customStyles={customStyles}
                    progressPending={isLoading}
                    noDataComponent={<div style={{ padding: '10px', textAlign: 'center', color: '#707070', fontFamily: 'Poppins', fontSize: '12px' }}>No Data Available</div>}
                    sortIcon={<span style={{ paddingLeft: '5px' }}>▼</span>}
                    sortIconRight
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}
